@if (isDialogVisible()) {
<section>
    <div class="uscb-layout-row uscb-bg-primary uscb-color-white">
        <span class="vcenter uscb-flex uscb-padding-TB-0 uscb-padding-LR-8">{{exportSurveyDialogData.title}}</span>
        <span class="vcenter">
            <mat-icon (click)="close(true)" (keyup.enter)="close(true)" tabindex="0" aria-hidden="false">close</mat-icon>
        </span>
    </div>

    @if (isDialogInitialized()) {
    <mat-dialog-content>
        <div class="dialog-content-padding">
            @if (exportSurveyDialogData.subheading) {
            <h4 class="xlg-text">{{exportSurveyDialogData.subheading}}</h4>
            }

            <span class="md-text top-padding" [innerHTML]="exportSurveyDialogData.message"></span>
            
            @if (exportSurveyDialogData.instructionHeading) {
            <h4 class="md-text top-padding ecorr-text-bold uscb-padding-T-15">{{exportSurveyDialogData.instructionHeading}}</h4>
            }

            @if (exportSurveyDialogData.instructions?.length) {
            <div class="uscb-flex-row uscb-padding-0">
                @for (instruction of exportSurveyDialogData.instructions; track instruction.platform; let i = $index) {
                <ng-container>
                    @if (i > 0) {
                    <span> | </span>
                    }
                    <a href="{{instruction.instructionLink}}" target="_blank" class="uscb-padding-LR-5">{{instruction.platform}}</a>
                </ng-container>
                }
            </div>
            }
        </div>
    </mat-dialog-content>
    }

    <mat-dialog-actions class="export-survey-dialog-actions uscb-layout-row-gt-md uscb-layout-column-md uscb-layout-column-sm uscb-layout-align-center-center">
        <button type="button" class="uscb-primary-button" (click)="cancel()" (keyup.enter)="cancel()" tabindex="0">{{exportSurveyDialogData.cancelButtonLabel}}</button>
    </mat-dialog-actions>
</section>
}